<mat-form-field appearance="outline" [ngClass]="fieldClass">
  <mat-label>
    <strong>{{label}}</strong>
  </mat-label>

  <mat-select
    [attr.id]="id"
    [(ngModel)]="selectedWallet"
    [compareWith]="compareWallets"
    (selectionChange)="onWalletSelect($event)"
    [disabled]="disabled || isLoadingWallets"
    [attr.data-testid]="dataTestId"
    >
    @for (wallet of walletsList; track wallet) {
      <mat-option [value]="wallet" [disabled]="wallet.id === null">
        @if (showWalletTypeIcon && wallet.id !== null) {
          <span>
            <img
              [src]="getSelectOptionImage(wallet.type)"
              style="max-width: 30px;"
              [alt]="wallet.type === 'COMPANY' ? 'Empresa' : 'Persona'"
              i18n-alt="@@walletTypeIcon"
              >
            </span>
          }
          {{wallet.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
